module.exports = __webpack_public_path__ + "img/interactive-complete.a2db8563.png";